module.exports = __webpack_public_path__ + "img/Semi-Elliptical-Attachment-L-48.0635caf7.png";